import { OutletListItem, OutletState } from '@ancon/wildcat-types'
import isOutletAcceptingPreOrders from '@ancon/wildcat-utils/outlet/isOutletAcceptingPreOrders'

export default function isOutletAcceptingOfflineOrders(outlet: OutletListItem) {
  const isAcceptingPreOrders = isOutletAcceptingPreOrders(
    outlet.orderFormatSettings,
  )

  const isOutletClosed = outlet.state === OutletState.Closed

  return isOutletClosed && isAcceptingPreOrders
}
